import React, { useState, useRef, useContext } from 'react';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Input from '@salesforce/design-system-react/components/input';
import InputIcon from '@salesforce/design-system-react/components/icon/input-icon';
import { LocalizationContext } from "../context/LocalizationContext";

/**
 * This component accepts two properties, the value prop represents an applied search
 * on the list. This can be used to determine if the search action or clear action should 
 * be visible. The onChange prop is a method that can be called to notify the parent
 * component that the usere wants to update the applied search criteria.
 * 
 * We use a 1 second timeout to delay the change event to prevent excessive onChange
 * calls when the user types quickly.
 * 
 * @param {value, onChange} param0 
 * @returns 
 */
function SearchText({ value, onChange }) {
	const i18n = useContext(LocalizationContext);
	const [searchText, setSearchText] = useState('');
	const timeoutRef = useRef(0);

	const handleInputChange = (event) => {
		let text = event.target.value;

		// Sanitize the user text. Fairly restrictive, but should be good enough for our purposes
		text = text.replace(/[^\w\d\s\._~-]/gm, '');

		setSearchText(text);

		clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(onChange, 1000, text);
	};

	const handleClear = (event) => {
		event.preventDefault();
		
		clearTimeout(timeoutRef.current);
		setSearchText('');
		onChange('');
	};

	// Allow the user to clear the search anytime we see there is a search applied
	const clearVisible = value != '';

	return (

		<IconSettings iconPath="/assets/icons">
			<Input
				iconLeft={
					<InputIcon
						assistiveText={{
							icon: 'Search'
						}}
						name="search"
						category="utility"
					/>
				}
				iconRight={clearVisible && (
					<InputIcon
						assistiveText={{
							icon: 'Clear'
						}}
						name="clear"
						category="utility"
						onClick={handleClear}
					/>
				)}
				label={i18n.get('EVENT_LABEL_SEARCH')}
				value={searchText}
				onChange={handleInputChange}
			/>
		</IconSettings>
	);
}

export default SearchText;